import React, { useState } from "react";
import { Button, Col, Form, Row } from "antd";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";

import image1 from "../../../../../../../../assets/images/owner-statement.jpeg";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function DelCityProcess({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {

    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <p className="blue-info-text">
              Once you complete this step you will want to delay the due date on
              this task so you can follow up and ensure the inspection permit
              has been received.
            </p>
          </Col>
          <Col span={24}>
            <p className="pink-info-text">
              if the property is in del city create a service request for a del
              city HIP Inspection and assign to someone to take the documents to
              del city and set up the time. Use this link to fill out the form
              needed for the service .{" "}
            </p>
          </Col>
          <Col span={24}>
            <p className="onclick-text">Inspection forms for del city</p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              In the service request put the following -attach form filled out
              from link -enter time and date of inspection that is set up (you
              can do this or reece if you are not able to go)
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text red-info-heading">
              Print out management agreement as well as the other forms
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              <span className="onclick-text">enter 2 bills</span>
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              1 - bill for $40 for temp water service (this is for 4 weeks of
              water service)
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              2 - bill for $40 for HIP (Housing Inspection Program) Inspection
              as broker to print and sign
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              3 - MAKE SURE AND TAKE THE CHECK WITH YOU FOR PAYMENT
            </p>
          </Col>
          <Col span={24}>
            <img className="owner-statement-img" src={image1} alt="" />
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={handleComplete}
                  disabled={isDisabled}
                >
                  Completed
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default DelCityProcess;
